import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=60a83a9c&scoped=true"
import script from "./PreviewImage.vue?vue&type=script&lang=js"
export * from "./PreviewImage.vue?vue&type=script&lang=js"
import style0 from "./PreviewImage.vue?vue&type=style&index=0&id=60a83a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_abc276eb37b0b1314bfe9ec856cc5e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a83a9c",
  null
  
)

export default component.exports